var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFileGold = function SvgIconFileGold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 39
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#988642",
    fillRule: "evenodd",
    d: "M12 26h12v3.25H12zm0-6.5h12v3.25H12zm9-16.25H9c-1.65 0-3 1.462-3 3.25v26c0 1.788 1.335 3.25 2.985 3.25H27c1.65 0 3-1.462 3-3.25V13zm6 29.25H9v-26h10.5v8.125H27z"
  })));
};
export default SvgIconFileGold;